module.exports = __webpack_public_path__ + "static/media/3_5.38f8902b.png";